import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, HttpRequestModel } from 'src/app/service/httpservice/http.service';
import { LocalstorageService } from '../shared/localstorage/localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class UnionLocalService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(
    private httpService: HttpService,
    private localStorageService: LocalstorageService,
  ) {}

  //Request to get all union locals
  getUnionLocals(searchInfo = null, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'locals';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = searchInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get all union locals
  getUnionLocalsById(localId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'locals/' + localId;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to add new union locals
  addUnionLocals(newLocal, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'locals/add';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = newLocal;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to update union locals
  updateUnionLocals(updateLocal, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'locals/update';
    this.HttpRequestModel.method = 'PUT';
    this.HttpRequestModel.body = updateLocal;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to delete union locals
  deleteUnionLocals(removeLocal, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'locals/delete/' + removeLocal;
    this.HttpRequestModel.method = 'DELETE';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
